import axios from "../api/axios";

export const getDoctors = async (token: string) => {
  const res = await axios.get("practitoner-roles", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      origin: "homepage",
    },
  });

  return res.data.data;
};